import i18n from "@/locales/i18n"
import nav from "./navigation"
import store from "./store"
import $store from "@/store"
import Vue from "vue"
import handler from "./eventHandler"
import loader from "./externalLoader"
import progress from "./progress"
import router from "./router"

class Utils {
  constructor() {
    this.intervals = new Set()
    this.timeouts = new Set()
    this.nav = nav
    this.store = store
    this.vue = new Vue({ i18n })
    this.handler = handler
    this.loader = loader
    this.progress = progress
    this.router = router
  }
  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }
  getLocalStorageSpace() {
    let allStrings = ""
    for (let key in window.localStorage) {
      if (window.localStorage.hasOwnProperty(key)) {
        allStrings += window.localStorage[key]
      }
    }
    return allStrings ? 3 + (allStrings.length * 16) / (8 * 1024) + " KB" : "Empty (0 KB)"
  }
  clearLocalStorage(key = null) {
    for (key in window.localStorage) {
      delete window.localStorage[key]
    }
    return true
  }
  error(e, feedback = false) {
    if (typeof e === "boolean") return false
    console.error(e.message || e)
    return feedback
  }
  log(log, feedback = true) {
    DEBUG && console.log(log)
    return feedback
  }
  splitUrl(uri) {
    const res = {
        initial: null,
        protocol: null,
        port: null,
        host: null,
        origin: null,
        path: null
      },
      regex = new RegExp("^(.*)://([A-Za-z0-9-.]+)+[:]*([0-9]+)?(.*)$"),
      result = regex.exec(uri)
    if (result) {
      res.initial = uri
      res.protocol = result[1]
      res.host = result[2]
      res.port = result[3]
      res.path = result[4]
      res.origin = res.protocol + "://" + res.host
    }

    return res
  }
  duration(seconds) {
    var hrs = ~~(seconds / 3600)
    var mins = ~~((seconds % 3600) / 60)
    var secs = ~~seconds % 60

    var ret = ""
    if (hrs > 0) {
      ret += "" + hrs + ":" + (mins < 10 ? "0" : "")
    }
    ret += "" + mins + ":" + (secs < 10 ? "0" : "")
    ret += "" + secs
    return ret
  }
  dummyEpg(date = new Date(), hours = 48, offset = 36) {
    const now = new Date().getTime()
    const epgs = []
    date.setHours(!offset ? 0 : date.getHours() - offset, 0, 0, 0)

    for (let index = 0; index < hours; index++) {
      const epg = {
        title: "N/A",
        start: date.getTime(),
        end: date.setHours(date.getHours() + 1)
      }
      if (epg.start <= now && epg.end >= now) epg.current = true
      epgs.push(epg)
    }

    return epgs
  }

  /* Array and Object Helpers */
  clone(object) {
    return typeof object === "object" ? JSON.parse(JSON.stringify(object)) : object
  }
  unique(value, index, self) {
    return value && self.indexOf(value) === index
  }
  getKeysByValue(object, value) {
    const temp = []
    Object.keys(object).map(key => {
      object[key] === value && temp.push(key)
    })
    if (temp.length === 0) return false

    return temp
  }
  getKeyByValue(object, value) {
    const res = Object.keys(object).find(key => object[key] === value)

    return res
  }
  random(length, chars) {
    var mask = ""
    if (chars.indexOf("a") > -1) mask += "abcdefghijklmnopqrstuvwxyz"
    if (chars.indexOf("A") > -1) mask += "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
    if (chars.indexOf("#") > -1) mask += "0123456789"
    if (chars.indexOf("!") > -1) mask += "~`!@#$%^&*()_+-={}[]:\";'<>?,./|\\"
    var result = ""
    for (var i = length; i > 0; --i) result += mask[Math.floor(Math.random() * mask.length)]
    return result
  }
  pad(value, howMany = "00") {
    return (howMany + value).slice(-howMany.length)
  }
  true(val) {
    const falsy = [false, undefined, null, NaN, 0, "", "0", "false"]
    return !falsy.includes(val)
  }
  untilZero(val) {
    return val < 0 ? 0 : val
  }
  removeFromArray(arr, value) {
    var index = arr.indexOf(value)
    if (index > -1) {
      arr.splice(index, 1)
    }
    return arr
  }
  async loadImage(uri, preventOnRoute = true, translated = false, fallback = null) {
    if (!window.webpackHotUpdate && uri?.startsWith("/assets")) uri = "/v2" + uri
    if (!window.webpackHotUpdate && fallback?.startsWith("/assets")) fallback = "/v2" + fallback
    let origin = uri,
      lang = $store?.getters["language"].code

    if (lang && translated) {
      lang = lang.split("_").shift()
      uri = uri.replace(/\/assets\//g, `/assets/${lang}/`)
    }

    let promise = await _$.progress.create()
    let img = new Image()
    let callback = () => {
      img.src = ""
      promise.reject()
    }

    img.onload = () => {
      _$.vue.$off("beforeRoute", callback)
      promise.resolve(img)
    }
    img.onerror = () => {
      _$.vue.$off("beforeRoute", callback)
      if (translated && !fallback && !img.src.includes(origin)) img.src = origin
      else if (fallback && !img.src.includes(fallback)) img.src = fallback
      else promise.reject()
    }

    img.src = uri
    if (preventOnRoute) _$.vue.$once("beforeRoute", callback)

    return promise.done
  }

  /* timeout and interval */

  // create another interval
  makeInterval(...args) {
    let newInterval = setInterval(...args)
    this.intervals.add(newInterval)
    return newInterval
  }
  // clear a single or all intervals
  removeInterval(id = null) {
    if (id) {
      this.intervals.delete(id)
      clearInterval(id)
    } else {
      for (let i of this.intervals) {
        this.removeInterval(i)
      }
    }
    return true
  }
  // create another timeout
  makeTimeout(...args) {
    let newTimeout = setTimeout(...args)
    this.timeouts.add(newTimeout)
    return newTimeout
  }
  // clear a single or all timeouts
  removeTimeout(id = null) {
    if (id) {
      this.timeouts.delete(id)
      clearTimeout(id)
    } else {
      for (let i of this.timeouts) {
        this.removeTimeout(i)
      }
    }
    return true
  }

  marquee(data, repeat, speed, selector) {
    const parentSelector = document.getElementById(selector)
    const text = document.createElement("h5")
    text.innerHTML = data
    parentSelector.innerHTML = text.outerHTML

    let customInterval = null
    const firstElement = parentSelector.children[0]
    let i = 0
    let _repeat = 0
    customInterval = setInterval(function() {
      if (repeat === _repeat) {
        _$.vue.$emit("marquee", "skip")
        clearInterval(customInterval)
        return
      }
      firstElement.style.right = `${i}px`
      if (i > parentSelector.clientWidth + firstElement.clientWidth) {
        i = 0
        _repeat++
      }
      i = i + speed
    }, 0)
  }
}

export default new Utils()
